import { Validator } from '../Validator';
import { isNullOrUndefined } from 'util';

export default class AmountInvestedService implements Validator {

  // tslint:disable-next-line no-any
  public getValidation(amountInvested: any, message: string = 'amountInvested'): Promise<void> {
    return new Promise(
      (res, error) => {
        if (isNullOrUndefined(amountInvested) || amountInvested < 1) {
          error(message);
        } else {
          res();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/validation/validators/AmountInvested.tsx